(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facetheory-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-ft-landing]').forEach((root) => {
      const track = root.querySelector('[data-ft-review-track]');
      if (!track || track.children.length < 2 || track.dataset.ready === 'true') return;
      track.dataset.ready = 'true';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const carousel = track.closest('.ft-proof__carousel');
      const pauseButton = carousel.querySelector('[data-ft-review-pause]');
      let timer;
      let paused = false;
      const move = (direction) => {
        const card = track.querySelector('.ft-review');
        if (!card) return;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        if (end <= 2) {
          if (direction > 0) track.appendChild(track.firstElementChild);
          else track.prepend(track.lastElementChild);
          return;
        }
        const left = direction > 0
          ? (track.scrollLeft >= end - 2 ? 0 : Math.min(track.scrollLeft + step, end))
          : (track.scrollLeft <= 2 ? end : Math.max(track.scrollLeft - step, 0));
        track.scrollTo({ left, behavior: reducedMotion ? 'auto' : 'smooth' });
      };
      carousel.querySelector('[data-ft-review-prev]').addEventListener('click', () => move(-1));
      carousel.querySelector('[data-ft-review-next]').addEventListener('click', () => move(1));
      pauseButton.addEventListener('click', () => {
        paused = !paused;
        pauseButton.setAttribute('aria-pressed', String(paused));
        pauseButton.setAttribute('aria-label', paused ? 'Reanudar opiniones' : 'Pausar opiniones');
        pauseButton.textContent = paused ? '▶ Reanudar' : 'Ⅱ Pausar';
        if (paused) clearInterval(timer);
        else start();
      });
      const start = () => {
        if (reducedMotion || paused) return;
        clearInterval(timer);
        timer = setInterval(() => move(1), 6000);
      };
      track.addEventListener('pointerenter', () => clearInterval(timer));
      track.addEventListener('pointerleave', start);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
